/** Shared layout dimensions for sidebar, header, and main content offset. */
export const DRAWER_WIDTH = 240
export const HEADER_HEIGHT = 64
export const ADMIN_BANNER_HEIGHT = 48

/** Temporary-drawer element id; hamburger `aria-controls` must match. */
export const APP_SHELL_NAV_DRAWER_ID = 'app-shell-nav-drawer'

/** Fixed header height including notch/status-bar inset (matches Header paddingTop). */
export const headerOffsetCss = `calc(${HEADER_HEIGHT}px + env(safe-area-inset-top, 0px))`

/** Fixed bottom tab bar height (Paper adds safe-area padding below this). */
export const BOTTOM_NAV_HEIGHT = 56
/** Live-session mini bar shown above bottom nav on small viewports. */
export const MINI_SESSION_BAR_HEIGHT = 48
/** Minimum touch target size (WCAG / mobile HIG). */
export const TOUCH_TARGET_MIN_PX = 44
